import { PageEvent } from "@angular/material/paginator";
import { coreEnvironment } from "src/environments/core/core-environment";

export class Paging {

  pagingPageSizeOptions = coreEnvironment.paging.pageOptions;
  pagingPageSize = coreEnvironment.paging.pageSize;
  offset = 0;
  length = 0;

  handlePageEvent(e: PageEvent) {
    this.offset = e.pageIndex * e.pageSize;
    this.pagingPageSize = e.pageSize;
  }
}
